import React, {Component} from 'react';
import {Config} from '../utils/Config';
import Grid from '@material-ui/core/Grid';
import {Button, ButtonGroup} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import {ticketDetails, passengerDetails} from '../actions/main';
import {LOCALSTORAGE_KEY} from '../utils/constants.js';
import {connect} from 'react-redux';
import {eraseCookie} from '../utils/cookieManager';
import '../App.scss';

class SeatLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seatLayout: [],
      boarding: [],
      dropping: [],
      showupper: false,
      showlower: true,
      isLoading: false,
      bookingdata: false,
      seatReserved: {},
      isSnackBarOpen: false,
      isAPSRTC: false,
      governmentId: '',
      slideUp: false,
      topHeight: 0,
    };
  }

  componentDidMount() {
    this.fetchUrl();
  }

  fetchUrl = () => {
    const state = this.props.searchQuery.seatapidata;
    const isAPSRTC = state.isAPSRTC;
    const sourceId = state.sid;
    const destinationId = state.did;
    const bus = state.bus;
    const doj = state.doj;

    this.setState({
      isLoading: true,
      name: bus.TravelsName,
      bus,
    });

    if (bus.RtcTag === 'APSRTC') {
      const url = `${Config.SECURED_API_HOST}/api/platform/bus/getboardingdroppingpoints?sourceMasterId=${sourceId}&destinationMasterId=${destinationId}&dateOfJourney=${doj}&serviceKey=${bus.Id}`;
      fetch(url)
        .then((res) => res.json())
        .then((res) => {
          if (res.Error === null) {
            res.ArrivalPoints.forEach((d) => {
              d.value = d.Id;
              d.label = d.Name + ' - ' + d.Time;
            });

            res.DeparturePoints.forEach((b) => {
              b.value = b.Id;
              b.label = b.Name + ' - ' + b.Time;
            });

            this.setState({
              boarding: res.DeparturePoints,
              dropping: res.ArrivalPoints,
              dropvalue: res.ArrivalPoints[0],
              isLoading: false,
              TravellerType: {value: 1, label: 'GENERAL PUBLIC'},
              isAPSRTC,
            });
          } else {
            this.openSnackBar(res.Error);
            this.setState({
              isLoading: false,
            });
          }

          // console.log(res);
        })
        .catch((error) => {
          console.log(error);
          this.openSnackBar('Something Went Wrong! Please Try again');
        });
    } else {
      const seatUrl = `${Config.SECURED_API_HOST}/api/platform/bus/tripdetails?sourceMasterId=${sourceId}&destinationMasterId=${destinationId}&dateOfJourney=${doj}&id=${bus.Id}`;
      fetch(seatUrl)
        .then((res) => res.json())
        .then((res) => {
          if (res.Error === null) {
            let seatselectObj = {};
            let seatLayout = res['map'];
            let boarding = res['DeparturePoints'];
            let dropping = res['ArrivalPoints'];
            console.log(res);

            boarding.forEach((b) => {
              b.value = b.Id;
              b.label = b.LocationDisplayName + ' - ' + b.Time;
            });

            // console.log(seatselectObj);
            dropping.forEach((d) => {
              d.value = d.Id;
              d.label = d.LocationDisplayName + ' - ' + d.Time;
            });

            seatLayout.forEach((s) => {
              s.SeatSelected = false;
              seatselectObj[s.SeatName] = s;
            });

            this.setState({
              seatLayout,
              boarding,
              dropping,
              isLoading: false,
              seatselectObj,
            });
          } else {
            this.openSnackBar('Something Went Wrong! Please Try Again');
            this.setState({
              isLoading: false,
            });
            setTimeout(() => {
              this.props.history.goBack();
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          this.openSnackBar('Somthing went wrong Please try Again');
        });
    }
    this.showCancellationspolicy();
  };

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  getAPSRTCseatLayout = () => {
    const state = this.props.searchQuery.seatapidata;
    const sourceId = state.sid;
    const destinationId = state.did;
    const bus = state.bus;
    const doj = state.doj;

    // for RTC buses seatLayout
    const boarding = this.state.boardvalue;
    const dropping = this.state.dropvalue;
    const TravellerType = this.state.TravellerType;

    if (boarding && dropping && TravellerType) {
      this.setState({
        isLoading: true,
      });
      const RTCseatURL = `${Config.SECURED_API_HOST}/api/platform/bus/tripdetails?sourceMasterId=${sourceId}&destinationMasterId=${destinationId}&dateOfJourney=${doj}&id=${bus.Id}&provider=APSRTC&destination=${dropping.Id}&source=${boarding.Id}&concessionType=${TravellerType.value}`;
      fetch(RTCseatURL)
        .then((res) => res.json())
        .then((res) => {
          if (res.Error === null) {
            let seatselectObj = {};
            let seatLayout = res['map'];
            console.log(seatLayout);

            seatLayout.forEach((s) => {
              s.SeatSelected = false;
              seatselectObj[s.SeatName] = s;
            });

            this.setState({
              seatLayout,
              seatselectObj,
              isLoading: false,
              seatReserved: {},
              rtcFare: 0,
              isSeatsLoaded: true,
            });
          } else {
            this.openSnackBar(res.Error);
            this.setState({
              isLoading: false,
            });
          }
          // console.log(res);
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          this.openSnackBar('Something went wrong! Please Try again');
        });
    } else {
      this.openSnackBar('Please Select Boarding Point!');
    }
  };

  getRTCPrice = (seat) => {
    this.setState({
      isLoading: true,
    });
    const bus = this.state.bus;
    const type = this.state.TravellerType;
    const boarding = this.state.boardvalue;
    const dropping = this.state.dropvalue;
    const url = `${Config.SECURED_API_HOST}/api/platform/bus/getFinalAmount?operatorId=${bus.BusTypeId}&serviceId=${bus.Id}&doj=${bus.DateOfJourney}&source=${boarding.Id}&destination=${dropping.Id}&childSeats=?&adultSeats=${seat.SeatName}&concessionId=${type.value}`;
    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        this.setState({
          rtcFare: res.totalAmount,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isLoading: false,
        });
        this.openSnackBar('SOmething Went Wrong! Please Try Again');
      });
  };

  SeatSelect = (seat) => {
    // debugger;
    let seatReserved = this.state.seatReserved;

    if (this.state.isAPSRTC) {
      if (this.state.rtcFare === 0) {
        this.getRTCPrice(seat);
      }
    }

    // let seatselectObj = { ...this.state.seatselectObj }

    function SeatSelect() {
      seat.SeatSelected === false
        ? (seat.SeatSelected = true)
        : (seat.SeatSelected = false);
    }

    // adding and removing seat to reserved array
    if (seat.SeatName in seatReserved) {
      delete seatReserved[seat.SeatName];
      this.setState({
        seatReserved,
      });
      SeatSelect();
    } else {
      if (seat.Available && Object.keys(seatReserved).length < 6) {
        if (this.state.isAPSRTC && this.state.TravellerType.value === 3) {
          if (Object.keys(seatReserved).length === 0) {
            seatReserved[seat.SeatName] = seat;
            this.setState({
              seatReserved,
            });
            SeatSelect();
          } else {
            this.openSnackBar('Senior Citizen can only Select One Seat');
          }
        } else {
          seatReserved[seat.SeatName] = seat;
          this.setState({
            seatReserved,
          });
          SeatSelect();
        }
      } else if (Object.keys(seatReserved).length === 6) {
        this.openSnackBar('Maximum 6 Seats can be Selected');
      }
    }

    // seatselectObj[seat.SeatName] = seat;
    // // if (seat.SeatSelected) {
    // //   console.log(seatselectObj.SeatName);
    // //   seat = seatselectObj[seat.SeatName];
    // // }

    // this.setState({
    //   seatselectObj
    // });
  };

  sizeCompute = (seat) => {
    // let h = this.state.topHeight;
    let width = parseInt(seat.SeatLayout.Width);
    let height = parseInt(seat.SeatLayout.Length);
    let left = parseInt(seat.SeatLayout.RowNo);
    let top = parseInt(seat.SeatLayout.ColumnNo);
    let isAvailable = seat.Available;
    let isLadies = seat.SeatLayout.LSeat;
    // if (top > h) this.setState({ topHeight: h });
    height = height * 25 + 'px';
    width = width * 25 + 'px';

    left = 200 - left * 30 + 'px';
    top = top * 30 + 50 + 'px';

    const style = {
      position: 'absolute',
      height: height,
      width: width,
      top: top,
      left: left,
      border: '1px solid #55a2bb',
      textAlign: 'center',
    };

    if (isAvailable) {
      isLadies ? (style.border = '1px solid #f78397') : (style.background = '');
    } else {
      isLadies
        ? (style.background = '#f78397')
        : (style.background = '#55a2bb');
      style.color = 'white';
      isLadies ? (style.border = '') : (style.border = '');
    }

    return (
      <div
        style={style}
        key={seat.SeatName}
        onClick={(e) => this.SeatSelect(seat)}
        className={seat.SeatSelected ? 'reserved' : ''}
      >
        {seat.SeatName}
      </div>
    );
  };

  handleOnClick = (type) => {
    if (type === 'lower') {
      this.setState({
        showlower: true,
        showupper: false,
      });
    } else if (type === 'upper') {
      this.setState({
        showlower: false,
        showupper: true,
      });
    }
  };

  handleSubmit = () => {
    // debugger;
    const ticket = this.state.seatReserved;
    const {
      boardvalue,
      dropvalue,
      governmentId,
      isAPSRTC,
      TravellerType,
      rtcFare,
    } = this.state;
    let info = [];
    let price = 0;
    const source = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_CITY)
    );
    //console.log(this.state);

    if (isAPSRTC && TravellerType.value === 3 && governmentId === '') {
      return this.updateStateObj(
        true,
        'governmentId',
        'Please Enter GovernmentId'
      );
    }
    // debugger;
    if (typeof boardvalue === 'undefined') {
      this.openSnackBar('Please Select Boarding Point');
      this.updateStateObj(true, 'board', 'Please Select Boarding Point');
    } else {
      var count = 0;
      for (var i in ticket) {
        isAPSRTC
          ? (price += parseFloat(rtcFare))
          : (price += parseFloat(ticket[i].SeatMapFare.ActualSeatFare));
        info.push({
          fare: ticket[i].SeatMapFare.ActualSeatFare,
          ladiesSeat: ticket[i].SeatLayout.LSeat.toString(),
          passenger: {
            address: source.data.city,
            title: ticket[i].SeatLayout.LSeat === true ? 'Ms' : 'Mr',
            name: '',
            primary: count === 0 ? 'true' : 'false',
            age: '',
            gender: ticket[i].SeatLayout.LSeat === true ? 'FEMALE' : 'MALE',
            mobile: null,
            idType: '',
            idNumber: null,
            email: '',
          },
          seatName: ticket[i].SeatName,
        });
        count++;
      }

      this.props.ticketDetails({
        ticketdetails: ticket,
        boarding: boardvalue,
        dropping: dropvalue,
        bus: this.state.bus,
        totalamount: price,
      });

      this.props.passengerDetails({
        passengerdetails: info,
      });

      eraseCookie('BlockRequest');
      eraseCookie('Paymentvisit');
      eraseCookie('TicketSummaryVisit');

      this.props.history.push({
        pathname: '/rbooking-bus/passenger-page',
        state: {
          TravellerType: isAPSRTC ? TravellerType.value : '',
          GovtId: governmentId !== '' ? governmentId : '',
        },
      });
    }
  };

  // updating error state for TextFields
  updateStateObj = (flag, name, message) => {
    // debugger;
    this.setState({
      [`${name}Err`]: flag,
      [`${name}ErrTxt`]: message,
    });
  };

  //calls when user gets seatlayout and selects different boarding or TravellerType
  getSeatLayout = () => {
    if (this.state.isAPSRTC && this.state.isSeatsLoaded) {
      this.getAPSRTCseatLayout();
    }
  };

  onSelect = (event, type) => {
    // debugger;
    if (type === 'boarding') {
      this.setState({boardvalue: event}, this.getSeatLayout);
    } else if (type === 'dropping') {
      this.setState({dropvalue: event}, this.getSeatLayout);
    } else if (type === 'TravellerType') {
      this.setState({TravellerType: event}, this.getSeatLayout);
    } else if (type === 'governmentId') {
      if (/^[a-zA-Z0-9]+$/.test(event.target.value)) {
        this.updateStateObj(false, 'governmentId', '');
      } else {
        this.updateStateObj(true, 'governmentId', 'Please Enter Valid Id');
      }
      this.setState({governmentId: event.target.value});
    }
  };

  showCancellationspolicy = () => {
    const bus = this.props.searchQuery.seatapidata.bus;
    var cancelPolicy = bus.CancellationPolicy.split(';');
    // console.log(cp);
    let policyTime = '';
    let policy = [];

    cancelPolicy.forEach((cp) => {
      if (cp === '') {
        return;
      }
      cp = cp.split(':');
      for (let i = 0; i < cp.length; i++) {
        if (cp[1] && cp[1] !== '-1') {
          policyTime = `${cp[2]}% - ${cp[0]} to ${cp[1]} hours before journey`;
        } else {
          if (cp[0] !== '')
            policyTime = `${cp[2]}% - ${cp[0]} hours before journey`;
        }
      }
      policy.push(policyTime);
    });
    if (bus.PartialCancellationAllowed === true) {
      policyTime = 'Partial Cancellation Allowed';
      policy.push(policyTime);
    } else {
      policyTime = 'Partial Cancellation Not Allowed';
      policy.push(policyTime);
    }
    // console.log(policy);

    this.setState({
      slideUp: !this.state.slideUp,
      policy,
    });
  };

  render() {
    let doj = this.props.searchQuery.seatapidata.doj;
    var date = new Date(doj);
    const header = (
      <div className="header">
        <Grid container justifyContent="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="seatTitle">
              <div>{this.state.name}</div>
              <span className="date"> {date.toDateString()}</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const {seatLayout, boarding, dropping} = this.state;
    const TravellerType = [
      {value: 1, label: 'GENERAL PUBLIC'},
      {value: 3, label: 'SENIOR CITIZEN'},
    ];

    let lowerdeck = [];
    let upperdeck = [];

    //if bus has upper n lower deck else default lowerdeck
    seatLayout.forEach((seat) => {
      if (parseInt(seat.SeatLayout.Height) === 0) {
        lowerdeck.push(seat);
      } else if (parseInt(seat.SeatLayout.Height) === 1) {
        upperdeck.push(seat);
      }
    });

    const lower = lowerdeck.map((l) => {
      return this.sizeCompute(l);
    });

    const upper = upperdeck.map((u) => {
      return this.sizeCompute(u);
    });

    const seatblock = this.state.isLoading ? (
      <div className="loading fixed">
        <CircularProgress />
      </div>
    ) : this.state.showlower ? (
      <div>
        {lower.length > 0 ? (
          <img
            src="https://www.confirmtkt.com/img/react/driverSeatlogo.png"
            alt="Drive seat"
            height="50px"
            width="50px"
            style={{position: 'relative', left: '180px', padding: '10px'}}
          />
        ) : (
          ''
        )}
        {lower}
      </div>
    ) : (
      upper
    );

    let GovtId = '';
    if (this.state.TravellerType) {
      GovtId =
        this.state.TravellerType.value === 3 ? (
          <div style={{margin: '10px', fontSize: '14px'}}>
            <TextField
              style={{margin: '0px'}}
              id="governmentId"
              label="Enter Governement Id"
              fullWidth
              margin="normal"
              error={
                this.state.governmentIdErr ? this.state.governmentIdErr : false
              }
              helperText={
                this.state.governmentIdErrTxt
                  ? this.state.governmentIdErrTxt
                  : ''
              }
              value={this.state.governmentId ? this.state.governmentId : ''}
              onChange={(e) => this.onSelect(e, 'governmentId')}
            />
          </div>
        ) : (
          ''
        );
    }

    // Traveller type for RTC Buses
    const RTCseatLayout = (
      <div>
        <div style={{margin: '10px'}}>
          <Select
            onChange={(e) => this.onSelect(e, 'TravellerType')}
            options={TravellerType}
            // defaultValue={TravellerType[0]}
            value={this.state.TravellerType}
            addPlaceholder="Traveller Type"
            placeholder="Select Traveller Type"
          />
        </div>
        <div style={{textAlign: 'center', marginBottom: '5px'}}>
          <button
            style={{fontSize: '1.4rem'}}
            className="btn btn-success"
            onClick={this.getAPSRTCseatLayout}
          >
            Show SeatLayout
          </button>
          {GovtId}
        </div>
      </div>
    );

    const switchbutton = (
      <div className="switch-button">
        <Grid item>
          <ButtonGroup color="primary" size="large">
            <Button
              variant="outlined"
              onClick={(e) => this.handleOnClick('lower')}
              style={{fontSize: '1.6rem'}}
            >
              Lower
            </Button>
            <Button
              variant="outlined"
              style={{fontSize: '1.6rem'}}
              onClick={(e) => this.handleOnClick('upper')}
            >
              Upper
            </Button>
          </ButtonGroup>
        </Grid>
      </div>
    );

    const sr = this.state.seatReserved;
    let seatlist = [];
    var price = 0;

    for (var k in sr) {
      // debugger;
      seatlist.push(k);
      this.state.isAPSRTC
        ? (price += parseFloat(this.state.rtcFare))
        : (price += parseFloat(sr[k].SeatMapFare.ActualSeatFare));
    }

    const boardndroppoints = (
      <div>
        <div style={{margin: '10px'}} onClick={this.openMenu}>
          <Select
            onChange={(e) => this.onSelect(e, 'boarding')}
            name="board"
            options={boarding}
            inputProps={{readOnly: true}}
            value={this.state.boardvalue}
            error={this.state.boardErr ? this.state.boardErr : false}
            helperText={this.state.boardErrTxt ? this.state.boardErrTxt : ''}
            addPlaceholder="Boarding point"
            placeholder="Select Boarding Points"
          />
        </div>
        <div style={{margin: '10px'}}>
          <Select
            inputProps={{readOnly: true}}
            onChange={(e) => this.onSelect(e, 'dropping')}
            options={dropping}
            // defaultValue={dropping[0]}
            value={this.state.dropvalue}
            addPlaceholder="Dropping point"
            placeholder="Select Dropping Points"
          />
        </div>
      </div>
    );

    const bottomMenu = (
      <div className="bottom-fixed-details">
        <Grid container>
          <Grid item xs={5} className="fare-info">
            Seats
            <br />
            <span className="seatName">{seatlist.join()}</span>
          </Grid>
          <Grid item xs={3} className="fare-info">
            Fare <br />
            <span className="price" style={{fontWeight: 'bold'}}>
              {'Rs ' + price}
            </span>
          </Grid>
          <Grid item xs={4}>
            <div
              variant="contained"
              className="ctkt-btn-success-bottom"
              onClick={this.handleSubmit}
            >
              CONTINUE
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const cpstyle = {
      textAlign: 'center',
      fontSize: '1.2rem',
    };

    // const cancellationPolicies = (
    //   <div className="bottom-fixed-details">
    //     <div>
    //       <div
    //         variant="contained"
    //         className="container cancellation-policy"
    //         onClick={this.showCancellationspolicy}
    //       >
    //         Cancellation Policies
    //       </div>
    //       <div>
    //         {this.state.slideUp
    //           ? this.state.policy.map((p, i) => {
    //               return (
    //                 <div key={i} style={cpstyle}>
    //                   {p}
    //                 </div>
    //               );
    //             })
    //           : ""}
    //       </div>
    //     </div>
    //   </div>
    // );

    const CancellationPolicy = this.state.slideUp
      ? this.state.policy.map((p, i) => {
          return (
            <div key={i} style={cpstyle}>
              {p}
            </div>
          );
        })
      : '';

    // const seatInformation = <div style={style}></div>;
    const seatInformation = (
      <div style={{textAlign: 'center'}}>
        <div className="seatInfo">
          <div>
            <span className="tag ladies"></span>
            <span className="text">Ladies</span>
          </div>
          <div>
            <span className="tag booked"></span>
            <span className="text">Booked</span>
          </div>
          <div>
            <span className="tag available"></span>
            <span className="text">Available</span>
          </div>
        </div>
      </div>
    );

    let UpperLowerButton;
    UpperLowerButton =
      upper.length > 0
        ? (UpperLowerButton = switchbutton)
        : (UpperLowerButton = '');

    return (
      <div className="bus-seatLayout" style={{paddingBottom: '16%'}}>
        {header}
        {boardndroppoints}
        {this.state.isAPSRTC ? RTCseatLayout : ''}
        {UpperLowerButton}
        {seatInformation}
        <div
          style={{
            border: '2px solid #cccccc',
            margin: '0% 10%',
            height: '450px',
          }}
          // className="scroll-div"
          // style={UpperLowerButton !== "" ? { height: "340px" } : null}
        >
          {/* <div className="seat-layout">{seatblock}</div> */}
          <div style={{position: 'relative'}}>{seatblock}</div>
        </div>
        {seatlist.length > 0 ? bottomMenu : ''}
        {/* {seatlist.length > 0 ? bottomMenu : cancellationPolicies} */}
        <div
          style={{
            margin: '10px',
            boxShadow: '0px 2px 3px #f7caca',
          }}
        >
          <h4
            style={{
              textAlign: 'center',
              background: '#eee',
              margin: '0px',
              padding: '5px',
            }}
          >
            {'Cancellation Charges'}
            <br />
            <span style={{fontSize: '1rem'}}>
              {this.state.isAPSRTC
                ? '(Please note that,Refund amount is indicative)'
                : ''}
            </span>
          </h4>

          {CancellationPolicy}
        </div>
        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={5000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ticketdetailsReducer: state.ticketdetailsReducer,
    searchQuery: state.searchReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ticketDetails: (res) => {
      dispatch(ticketDetails(res));
    },
    passengerDetails: (res) => {
      dispatch(passengerDetails(res));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SeatLayout);
